<template>
  <div v-if="initFlag" class="ai-meeting-followup">
    <div class="ai-meeting-followup__card">
      <div class="ai-meeting-followup__card-title"><span>基本信息</span></div>
      <div class="ai-meeting-followup__card-label"><span>*</span>规则名称</div>
      <div class="ai-meeting-followup__card-input">
        <el-input v-model="ruleData.name" :maxlength="15" placeholder='例："电销部门提炼规则"' />
      </div>
      <div class="ai-meeting-followup__card-label">适用范围</div>
      <div class="ai-meeting-followup__card-input">
        <PermissionSelect
          v-model:show-all-company="showAllCompany"
          v-model:user-range="ruleData.userRangePojo"
        />
      </div>
    </div>
    <div class="ai-meeting-followup__card">
      <div class="ai-meeting-followup__card-title">
        <span> 提炼规则 </span>
        <i
          v-show="typeValue === 0"
          class="ai-meeting-followup__card-title-flod icon-arrow-up-double-line t-iconfont"
          :style="{
            transform: summaryUnFlod ? 'rotate(180deg)' : ''
          }"
          @click="summarysFold"
        ></i>
      </div>
      <!-- 规则选择 -->
      <div class="ai-meeting-followup__card-rule-select">
        <el-radio-group v-if="enableLiberalRules && ifRulesChoose" v-model="typeValue">
          <el-radio :label="1">自由规则</el-radio>
          <el-radio :label="0"
            >格式化规则
            <el-popover trigger="hover" width="auto">
              <img :src="require('@/assets/extract-rule-example.png')" />
              <template #reference>
                <i
                  class="ai-meeting-followup__card-title-example icon-question-line t-iconfont"
                ></i>
              </template> </el-popover
          ></el-radio>
        </el-radio-group>
        <AiPolish
          ref="aiPolishRef"
          :disabled="!showliberalRule.trim() || polishLoading"
          :params="polishParams"
          @end="handlePolishEnd"
          @start="handlePolishStart"
          @success="handlePolishSuccess"
          @withdraw="handleWithdrawPolish"
        />
      </div>
      <!-- 规则内容 -->
      <div
        class="ai-meeting-followup__card-rule"
        :class="{ 'is-free': enableLiberalRules && typeValue === 1 }"
      >
        <template v-if="!enableLiberalRules || (enableLiberalRules && typeValue === 0)">
          <div
            v-for="(summary, summaryIndex) in ruleData?.metricRulePojo?.contentMetricRule?.summary"
            :key="summaryIndex"
            class="ai-meeting-followup__card-rule-item"
          >
            <div class="ai-meeting-followup__card-rule-item-title">
              <span>提炼模块</span>
              <div class="ai-meeting-followup__card-rule-item-title-operate">
                <i
                  v-if="summaryIndex > 0"
                  class="icon-arrow-up-line t-iconfont"
                  @click.stop="summarysMoveUp(summaryIndex)"
                ></i>
                <i
                  v-if="
                    summaryIndex < ruleData?.metricRulePojo?.contentMetricRule?.summary?.length - 1
                  "
                  class="icon-arrow-down-line t-iconfont"
                  @click.stop="summarysMoveDown(summaryIndex)"
                ></i>
                <i
                  class="icon-delete-bin-line t-iconfont"
                  @click.stop="summarysRemoveItem(summaryIndex)"
                ></i>
              </div>
            </div>
            <div class="ai-meeting-followup__card-rule-item-level1">
              <i
                class="icon-arrow-down-s-line t-iconfont"
                :style="{
                  transform: summary.itemUnFlod ? 'rotate(180deg)' : ''
                }"
                @click="itemValuesFold(summaryIndex)"
              ></i>
              <el-input
                v-model="summary.itemName"
                :maxlength="10"
                placeholder='一级指标，例："客户需求"'
              ></el-input>
            </div>
            <template
              v-for="(itemValue, itemValueIndex) in summary.itemValues"
              :key="itemValueIndex"
            >
              <div v-show="!summary.itemUnFlod" class="ai-meeting-followup__card-rule-item-level2">
                <div class="ai-meeting-followup__card-rule-item-level2-title">
                  <span>模块重点</span>
                  <div>
                    <i
                      v-if="itemValueIndex > 0"
                      class="icon-arrow-up-line t-iconfont"
                      @click.stop="itemValuesMoveUp(summaryIndex, itemValueIndex)"
                    ></i>
                    <i
                      v-if="itemValueIndex < summary.itemValues?.length - 1"
                      class="icon-arrow-down-line t-iconfont"
                      @click.stop="itemValuesMoveDown(summaryIndex, itemValueIndex)"
                    ></i>
                    <i
                      class="icon-delete-bin-line t-iconfont"
                      @click.stop="itemValuesRemoveItem(summaryIndex, itemValueIndex)"
                    ></i>
                  </div>
                </div>
                <el-input
                  v-model="itemValue.ruleName"
                  :maxlength="10"
                  placeholder='二级指标，例："项目背景"'
                  show-word-limit
                ></el-input>
                <el-input
                  v-model="itemValue.ruleValue"
                  :autosize="{ minRows: 1, maxRows: 6 }"
                  :maxlength="300"
                  placeholder="描述模块重点的核心内容帮助 跟进助手的理解"
                  show-word-limit
                  type="textarea"
                ></el-input>
              </div>
            </template>
            <div
              v-show="!summary.itemUnFlod"
              class="ai-meeting-followup__card-rule-item-add"
              :style="{
                color: summary.itemValues?.length >= 6 ? '#C8C9CC' : '#7a52f4'
              }"
              @click="itemValuesAdd(summaryIndex)"
            >
              + 添加（{{ summary.itemValues?.length }}/6）
            </div>
          </div>
          <div
            v-if="ruleData?.metricRulePojo?.contentMetricRule?.summary?.length > 0"
            class="ai-meeting-followup__card-rule-divider"
          ></div>
          <div
            class="ai-meeting-followup__card-rule-add"
            :style="{
              color:
                ruleData?.metricRulePojo?.contentMetricRule?.summary?.length >= 3
                  ? '#C8C9CC'
                  : '#7a52f4'
            }"
            @click="summarysAdd"
          >
            + 添加提炼模块（{{ ruleData?.metricRulePojo?.contentMetricRule?.summary?.length }}/3）
          </div>
        </template>
        <template v-else-if="enableLiberalRules && typeValue === 1">
          <div v-show="polishLoading" class="ai-meeting-followup__content-skeleton">
            <div class="ai-meeting-followup__content-skeleton-inner">
              <el-skeleton animated>
                <template #template>
                  <div class="ai-meeting-followup__content-skeleton-rows">
                    <el-skeleton-item
                      class="ai-meeting-followup__content-skeleton-row"
                      variant="text"
                    />
                    <el-skeleton-item
                      class="ai-meeting-followup__content-skeleton-row"
                      variant="text"
                    />
                    <el-skeleton-item
                      class="ai-meeting-followup__content-skeleton-row ai-meeting-followup__content-skeleton-row--short"
                      variant="text"
                    />
                    <el-skeleton-item
                      class="ai-meeting-followup__content-skeleton-row ai-meeting-followup__content-skeleton-row--medium"
                      variant="text"
                    />
                  </div>
                </template>
              </el-skeleton>
            </div>
          </div>
          <el-input
            v-show="!polishLoading"
            v-model="showliberalRule"
            :maxlength="2000"
            :minlength="10"
            placeholder="请输入内容"
            :rows="14"
            show-word-limit
            type="textarea"
            @input="checkChangeAiPrompt"
          >
          </el-input>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import { ElMessage } from 'element-plus'
import xbb from '@xbb/xbb-utils'
import PermissionSelect from '@/components/ai-person-select/permission-select.vue'
import AiPolish from '@/components/ai-polish/index.vue'

// import PersonSelect from '@/components/person-select/index'

const emits = defineEmits(['update:isLiberalRules', 'update:liberalRule'])

// Props
const props = defineProps({
  operateData: {
    type: Object,
    default: () => ({})
  },
  enableLiberalRules: {
    // 是否开启自由规则 0是否，1是开启
    type: Number,
    default: 0
  },
  ifRulesChoose: {
    type: Boolean,
    default: true
  },
  isLiberalRules: {
    type: Number,
    default: 0
  },
  liberalRule: {
    type: String,
    default: ''
  }
})

// 响应式数据
const ruleData = reactive({})
const summaryUnFlod = ref(false) // 提炼规则是否收起
const initFlag = ref(false)
const showAllCompany = ref(!props.operateData.userRangePojo.length)
const aiPolishRef = ref(null)
const polishLoading = ref(false)
const lastOriginalLiberalRule = ref('')

const typeValue = computed({
  get() {
    return props.isLiberalRules
  },
  set(val) {
    emits('update:isLiberalRules', val)
  }
})

const showliberalRule = computed({
  get() {
    return props.liberalRule
  },
  set(val) {
    emits('update:liberalRule', val)
  }
})

const polishParams = computed(() => ({
  sceneType: 2,
  userPrompt: showliberalRule.value
}))

// 生命周期
onMounted(() => {
  Object.assign(ruleData, xbb.deepClone(props.operateData))
  initFlag.value = true
})

const handlePolishSuccess = (result) => {
  if (!result) return
  lastOriginalLiberalRule.value = showliberalRule.value
  showliberalRule.value = result
}

const handlePolishStart = () => {
  polishLoading.value = true
}

const handlePolishEnd = () => {
  polishLoading.value = false
}

const handleWithdrawPolish = () => {
  if (!lastOriginalLiberalRule.value) return
  showliberalRule.value = lastOriginalLiberalRule.value
  lastOriginalLiberalRule.value = ''
}

const checkChangeAiPrompt = (value) => {
  if (aiPolishRef.value?.success && lastOriginalLiberalRule.value !== value) {
    aiPolishRef.value.reset()
  }
}

// 提炼规则展开收起
const summarysFold = () => {
  // 切换整体折叠状态
  summaryUnFlod.value = !summaryUnFlod.value

  // 同步各提炼模块的展开/收起状态：
  const list = ruleData?.metricRulePojo?.contentMetricRule?.summary || []
  if (!Array.isArray(list) || list.length === 0) return

  if (summaryUnFlod.value) {
    list.forEach((s) => {
      s.itemUnFlod = true
    })
  } else {
    list.forEach((s) => {
      s.itemUnFlod = false
    })
  }
}

// 提炼模块展开收起
const itemValuesFold = (index) => {
  if (ruleData?.metricRulePojo?.contentMetricRule?.summary[index]) {
    ruleData.metricRulePojo.contentMetricRule.summary[index].itemUnFlod =
      !ruleData.metricRulePojo.contentMetricRule.summary[index].itemUnFlod
  }
}

// 提炼模块新增
const summarysAdd = () => {
  if (ruleData?.metricRulePojo?.contentMetricRule?.summary?.length >= 3) return
  ruleData?.metricRulePojo?.contentMetricRule?.summary.push({
    itemName: '',
    itemValues: [
      {
        ruleName: '',
        ruleValue: ''
      }
    ]
  })
}

// 提炼模块上移
const summarysMoveUp = (index) => {
  if (index > 0) {
    const summarys = ruleData?.metricRulePojo?.contentMetricRule?.summary || []
    summarys.splice(index - 1, 0, summarys.splice(index, 1)[0])
  }
}

// 提炼模块下移
const summarysMoveDown = (index) => {
  if (index < ruleData?.metricRulePojo?.contentMetricRule?.summary?.length - 1) {
    const summarys = ruleData?.metricRulePojo?.contentMetricRule?.summary || []
    summarys.splice(index + 1, 0, summarys.splice(index, 1)[0])
  }
}

// 提炼模块删除
const summarysRemoveItem = (index) => {
  const summarys = ruleData?.metricRulePojo?.contentMetricRule?.summary || []
  if (summarys.length <= 1) {
    ElMessage.error('至少保留一个指标')
    return
  }
  ruleData?.metricRulePojo?.contentMetricRule?.summary?.splice(index, 1)
}

// 模块重点新增
const itemValuesAdd = (index) => {
  if (ruleData?.metricRulePojo?.contentMetricRule?.summary[index].itemValues?.length >= 6) return
  ruleData?.metricRulePojo?.contentMetricRule?.summary[index].itemValues?.push({
    ruleName: '',
    ruleValue: ''
  })
}

// 模块重点上移
const itemValuesMoveUp = (summaryIndex, itemValueIndex) => {
  if (itemValueIndex > 0) {
    const itemValues = ruleData?.metricRulePojo?.contentMetricRule?.summary[summaryIndex].itemValues
    itemValues.splice(itemValueIndex - 1, 0, itemValues.splice(itemValueIndex, 1)[0])
  }
}

// 模块重点下移
const itemValuesMoveDown = (summaryIndex, itemValueIndex) => {
  if (
    itemValueIndex <
    ruleData?.metricRulePojo?.contentMetricRule?.summary[summaryIndex].itemValues?.length - 1
  ) {
    const itemValues =
      ruleData?.metricRulePojo?.contentMetricRule?.summary[summaryIndex].itemValues || []
    itemValues.splice(itemValueIndex + 1, 0, itemValues.splice(itemValueIndex, 1)[0])
  }
}

// 模块重点删除
const itemValuesRemoveItem = (summaryIndex, itemValueIndex) => {
  const itemValues =
    ruleData?.metricRulePojo?.contentMetricRule?.summary[summaryIndex].itemValues || []
  if (itemValues.length <= 1) {
    ElMessage.error('至少保留一个指标')
    return
  }
  ruleData?.metricRulePojo?.contentMetricRule?.summary[summaryIndex].itemValues.splice(
    itemValueIndex,
    1
  )
}

defineExpose({
  ruleData
})
</script>

<style lang="scss" scoped>
.ai-meeting-followup {
  display: flex;
  flex-direction: column;
  height: inherit;
  .ai-meeting-followup__card {
    i {
      cursor: pointer;
    }
    .ai-meeting-followup__card-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      color: #323233;
      .ai-meeting-followup__card-title-flod {
        font-size: 20px;
        color: #969799;
      }
      .ai-meeting-followup__card-title-example {
        margin-left: 4px;
        font-size: 16px;
        &:hover {
          color: #7a52f4;
        }
      }
      > span {
        display: flex;
        align-items: center;
        &::before {
          display: inline-block;
          flex-shrink: 0;
          width: 4px;
          height: 16px;
          margin-right: 8px;
          content: '';
          background: #7a52f4;
        }
      }
    }

    .ai-meeting-followup__card-label {
      margin-bottom: 8px;
      font-size: 14px;
      color: #323233;
      span {
        font-size: 14px;
        color: #f54e4e;
      }
    }
    .ai-meeting-followup__card-input {
      width: 480px;
      margin-bottom: 16px;
    }
    .ai-meeting-followup__card-permission {
      display: flex;
      width: 480px;
      overflow: hidden;
      border: 1px solid #e5e6eb;
      border-radius: 4px;
      .ai-meeting-followup__card-permission-text {
        :deep(.el-tag) {
          margin-left: 6px;
        }
        box-sizing: border-box;
        display: flex;
        flex: auto;
        align-items: center;
        height: 32px;
        padding-right: 15px;
        padding-left: 9px;
        overflow-x: auto;
        line-height: 30px;
        cursor: pointer;
      }
      .ai-meeting-followup__card-permission-btn {
        display: flex;
        align-items: center;
        margin: 0 12px 0 8px;
      }
    }
    .ai-meeting-followup__card-rule {
      :deep(.el-input) {
        width: 228px;
        margin-bottom: 0;
      }
      display: flex;
      flex-direction: column;
      justify-content: center;
      border: 1px solid #e5e6eb;
      border-radius: 8px;
      .ai-meeting-followup__content-skeleton {
        width: 100%;
        // 拿到element 输入框的高度，未来可以根据Ref来拿最准确的
        height: 367px;
      }
      .ai-meeting-followup__content-skeleton-inner {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 8px 11px;
        overflow: hidden;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0 0 0 1px var(--el-input-border-color, #dcdfe6) inset;
      }
      .ai-meeting-followup__content-skeleton-rows {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }
      .ai-meeting-followup__content-skeleton-row {
        width: 100%;
        height: 20px;
        border-radius: 8px;
      }
      .ai-meeting-followup__content-skeleton-row--short {
        width: 60%;
      }
      .ai-meeting-followup__content-skeleton-row--medium {
        width: 30%;
      }

      .ai-meeting-followup__card-rule-item {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 12px;
        .ai-meeting-followup__card-rule-item-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #969799;
        }
        .ai-meeting-followup__card-rule-item-level1 {
          display: flex;
          align-items: center;
          i {
            margin-right: 8px;
          }
        }
        .ai-meeting-followup__card-rule-item-level2 {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 12px;
          margin-left: 24px;
          background: #f7f8fa;
          border-radius: 8px;
          .ai-meeting-followup__card-rule-item-level2-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #969799;
          }
        }
        .ai-meeting-followup__card-rule-item-add {
          margin-left: 24px;
          cursor: pointer;
        }
      }
      .ai-meeting-followup__card-rule-divider {
        height: 1px;
        margin: 0 12px;
        background: #e5e6eb;
      }
      .ai-meeting-followup__card-rule-add {
        padding: 12px;
        cursor: pointer;
      }
    }
    .ai-meeting-followup__card-rule-select {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
    }
    .is-free {
      border: unset;
    }
    .ai-meeting-followup__card-checkbox {
      display: flex;
      flex-direction: column;
      .ai-meeting-followup__card-checkbox-title {
        font-weight: 600;
        color: #323233;
      }
      .ai-meeting-followup__card-checkbox-desc {
        margin-left: 24px;
        font-size: 13px;
        color: #969799;
      }
    }
  }
}
</style>
